import * as React from 'react'
import { ReactComponent as IconChipSolidWall } from '../icons/IconChipSolidWall.svg'
import { ReactComponent as IconChipFramedWall } from '../icons/IconChipFramedWall.svg'
import { ReactComponent as IconChipColumn } from '../icons/IconChipColumn.svg'
import { ReactComponent as IconChipFraming } from '../icons/IconChipFraming.svg'
import { ReactComponent as IconChipMetalDeck } from '../icons/IconChipMetalDeck.svg'
import { ReactComponent as IconChipSolidHoriz } from '../icons/IconChipSolidHoriz.svg'
import { AssemblyHorizontal, WallType, kind } from '../internalModules'
import { Box } from '@mui/material'

type Props = {
  layerKind: string,
  assembly?: WallType,
}

export default function UILayerIcon({layerKind, assembly}: Props) {

  const imageSize = 36
  const rightMargin = 1

  function showSolidGraphic(){
    if (layerKind === kind.solid) {
      if(assembly instanceof AssemblyHorizontal){
        return(
          <Box marginRight={rightMargin}>
            <IconChipSolidHoriz height={imageSize}/>
          </Box>
        )
      }
      if(assembly instanceof WallType){
        return(
          <Box marginRight={rightMargin}>
            <IconChipSolidWall height={imageSize}/>
          </Box>
        )
      }
      else{
        return(
          <Box marginRight={rightMargin}>
            <IconChipSolidWall height={imageSize}/>
            <IconChipSolidHoriz height={imageSize}/>
          </Box>
        )
      }
    }
    else { return(<></>)}
  }

  function showFramedGraphic(){
    if (layerKind === kind.framed) {
      return(
        <Box marginRight={rightMargin}>
          <IconChipFramedWall height={imageSize}/>
        </Box>
      )
    }
    else { return(<></>)}
  }

  function showColumnGraphic(){
    if (layerKind === kind.column) {
      return(
        <Box marginRight={rightMargin}>
          <IconChipColumn height={imageSize}/>
        </Box>

      )
    }
    else { return(<></>)}
  }

  function showFramingGraphic(){
    if (layerKind === kind.framing) {
      return(
        <Box marginRight={rightMargin}>
          <IconChipFraming height={imageSize}/>
        </Box>
      )
    }
    else { return(<></>)}
  }

  function showMetalDeckGraphic(){
    if (layerKind === kind.mDeck) {
      return(
        <Box marginRight={rightMargin}>
          <IconChipMetalDeck height={imageSize}/>
        </Box>
      )
    }
    else { return(<></>)}
  }

  return(
    <>
      {showSolidGraphic()}
      {showFramedGraphic()}
      {showColumnGraphic()}
      {showFramingGraphic()}
      {showMetalDeckGraphic()}
    </>
  )
}